// extracted by mini-css-extract-plugin
export default {"container":"UiLabel_container_iIaV2","icon":"UiLabel_icon_QKbJ1","label":"UiLabel_label_pTOAI"};